<script lang="ts">
    import type { NavButton } from './Segments.types';

    interface Props {
        segment: NavButton | undefined;
        paginate: (offset: number) => void;
    }

    let { segment, paginate }: Props = $props();

    const navButtons = {
        previous: {
            title: 'zurück',
            symbol: '<',
        },
        next: {
            title: 'weiter',
            symbol: '>',
        },
    };
    const pageLinkButton = $derived(segment ? navButtons[segment.type] : undefined);
</script>

{#if segment && pageLinkButton}
    <li
        class="reptile-segment-nav-button__item"
        data-qa="reptile-paging-{segment.type}"
        data-testid="reptile-segment-nav-button--{segment.type}"
    >
        <button
            class={['reptile-segment-nav-button__button', 'reptile-segment-nav-button__button--neighbour']}
            onclick={() => paginate(segment.offset)}
        >
            <span title={pageLinkButton.title}>{pageLinkButton.symbol}</span>
        </button>
    </li>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/colors';

    .reptile-segment-nav-button {
        &__item {
            float: left;
            min-width: 30px;
            font-weight: normal;
            text-align: center;
        }

        &__button {
            font-family: var(--oc-base-font-otto-sans), sans-serif;
            display: block;
            padding: 5px tokens.$oc-base-dimension-16;
            text-decoration: none;
            box-sizing: border-box;
            font-size: 0.75rem;
            line-height: 1.5em;
            background-clip: padding-box;
            border: medium none;
            border-radius: 3px;
            cursor: pointer;
            margin-bottom: 0;
            margin-top: 0;
            outline: 0 none;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            font-weight: 400;
            text-align: center;
            width: 100%;
            min-height: 30px;

            &--neighbour {
                font-family: OttoIcons, Arial, Helvetica, sans-serif !important;
                background: colors.$reptile-color-red-dark;
                color: colors.$reptile-color-white;

                & span {
                    font-style: normal !important;
                    font-size: 1.25em;
                }
            }
        }
    }
</style>
